<template>
  <div
    class="input-wrapper all-day-wrapper position-relative"
    ref="focusableDiv"
  >
    <span class="ver-center" @click="handleShowDropDown">Email</span>
    <div class="pl-100 all-email-info">
      <template v-if="showSingleInput && email.length < 2">
        <input
          :value="email.length > 0 ? email[0] : ''"
          type="text"
          @input="setEmail({ value: $event.target.value, index: 0 })"
          @focus="showExtras = true"
          class="title mb-0 pb-0 font-16"
          ref="focusThis"
        />
        <a
          href="#"
          class="add-email"
          v-if="showExtras"
          @click.stop.prevent="showSingleInput = false"
        >
          <img src="../../../assets/img/m_plus.png" alt="Add more email" />
        </a>
      </template>

      <div class="user-email-list" ref="mainDiv" v-else>
        <p>
          <span v-if="lastSelectedEmail === -1">Select</span>
          <span v-else>
            {{
              email[lastSelectedEmail] === ""
                ? "No value"
                : email[lastSelectedEmail]
            }}
          </span>
          <a href="#" class="email-dropdown" @click.prevent>
            <img src="../../../assets/img/drop-white.png" alt="Dropdown" />
          </a>
        </p>
      </div>

      <!-- Inner -->
      <transition name="expand">
        <div
          @mousedown="handlePreventHide"
          class="email-edit-con"
          v-if="showDropDown"
        >
          <email-inner
            v-if="email.length >= 1"
            :value="email[0]"
            :set-last-selected-email="setLastSelectedEmail"
            :index="0"
          />
          <email-inner
            v-if="email.length >= 2"
            :set-last-selected-email="setLastSelectedEmail"
            :value="email[1]"
            :index="1"
          />
          <div class="email-info no-bor" v-if="email.length < 2">
            <a href="#" class="email-add" @click.prevent="addEmail">
              <img src="../../../assets/img/m_plus.png" alt="Add email" />Add
              Email
            </a>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import EmailInner from "./EmailInner";
import { mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      showExtras: false,
      showSingleInput: true,
      showDropDown: false,
      preventHide: false,
      lastSelectedEmail: -1
    };
  },
  computed: {
    ...mapGetters("addNew", {
      email: "getEmail"
    })
  },
  methods: {
    ...mapMutations("addNew", {
      setEmail: "setEmail"
    }),
    handlePreventHide() {
      this.preventHide = true;
    },
    handleShowDropDown() {
      if (!this.showSingleInput || this.email.length > 1) {
        this.showDropDown = !this.showDropDown;
        this.handlePreventHide();
      }
    },
    setEventListener() {
      if (this.$refs.mainDiv !== undefined) {
        this.$refs.mainDiv.addEventListener("click", this.handleShowDropDown);
        window.addEventListener("click", this.handleHideDropDown);
      }
    },
    handleHideDropDown() {
      setTimeout(() => {
        if (this.preventHide) {
          this.preventHide = false;
          return;
        }
        this.showDropDown = false;
      }, 0);
    },
    addEmail() {
      this.setEmail({
        value: "",
        index: this.email.length
      });
    },
    setLastSelectedEmail(index) {
      this.lastSelectedEmail = index;
    }
  },
  components: {
    EmailInner
  },
  watch: {
    showSingleInput(value) {
      if (!value) {
        this.addEmail({ value: "", index: this.email.index });
        this.setLastSelectedEmail(0);
        this.$nextTick(() => {
          this.setEventListener();
        });
        setTimeout(() => {
          setTimeout(() => {
            this.showDropDown = true;
          });
        });
      }
    }
  },
  created() {
    if (this.email.length >= 1) {
      this.lastSelectedEmail = 0;
    }
  },
  mounted() {
    this.$nextTick(() => {
      // Drop down event listener
      this.setEventListener();

      // Focus event listener
      this.$refs.focusableDiv.addEventListener("click", () => {
        if (this.$refs.focusThis !== undefined) {
          this.$refs.focusThis.focus();
        }
      });
    });
  }
};
</script>

<style scoped>
.all-email-info input {
  width: 100%;
  max-width: 320px;
}

.all-email-info a.add-email img {
  width: 18px;
  height: 18px;
  display: block;
  margin-left: 5px;
}

a.add-email {
  top: 0;
  position: relative;
  margin-left: 45px;
  display: inline-block;
}

.user-email-list {
  max-width: 270px;
  width: 100%;
  color: #000;
  background: #fff;
  padding: 0px 0 0 10px;
  border-radius: 4px;
  border: 1px solid #4089c5;
  margin: 0px 0px 0px -10px;
}

.user-email-list p {
  line-height: 24px;
  margin: 0;
}

a.email-dropdown {
  /* display: inline-block; */
  float: right;
  background: #4089c5;
  text-align: center;
  width: 30px;
}

.email-edit-con {
  background: #fff;
  padding: 5px 10px 0 10px;
  border-radius: 5px;
  max-width: 260px;
  border: 1px solid #ccc;
  position: absolute;
  z-index: 3;
  display: block;
  margin-left: -9px;
  width: 100%;
  top: 39px;
}

.sticky-header .header-icon-contain img {
  width: auto;
}

div >>> .email-info {
  position: relative;
  margin: 5px auto;
  border-bottom: 1px solid #ccc;
  padding-bottom: 5px;
  width: 100%;
  height: 40px;
}
.email-info:last-child {
  border-bottom: 0;
}

div >>> .email-info a {
  text-decoration: none;
}

div >>> .email-info input {
  float: left;
  padding: 7px 5px;
  border: 1px solid #ccc !important;
  max-width: 215px;
}

div >>> .email-delete,
.email-add {
  display: inline-block;
  vertical-align: middle;
  position: absolute;
  right: 0;
}
div >>> .email-add {
  left: 0;
}

div >>> .email-delete {
  top: 10px;
}

a.email-add img {
  margin-right: 10px;
  position: relative;
  top: 5px;
}

div >>> .email-delete img,
.email-add img {
  max-width: 18px;
}

.no-bor {
  border: none;
}
.expand-leave-active {
  animation: contract 0.1s ease-in-out forwards;
}

.expand-enter-active {
  animation: expand 0.1s ease-in-out forwards;
}

@media screen and (min-width: 321px) and (max-width: 480px) {
  .all-email-info input {
    width: calc(100% - 60px);
  }
  a.add-email {
    margin-left: 13px;
  }
  .user-email-list {
    max-width: 220px;
    float: right;
    margin-right: 10px;
    max-height: 24px;
  }
  .user-email-list p span {
    max-width: 175px;
    display: inline-block;
    overflow: hidden;
  }
  .email-edit-con {
    right: 0;
    top: 30px;
  }
}

@media screen and (max-width: 320px) {
  .all-email-info input {
    width: calc(100% - 60px);
  }
  a.add-email {
    margin-left: 13px;
  }
  .user-email-list {
    max-width: 175px;
    max-height: 24px;
  }
  .user-email-list p span {
    max-width: 135px;
    display: inline-block;
    overflow: hidden;
  }
  .email-edit-con {
    right: 0;
    top: 30px;
  }
}

@keyframes expand {
  from {
    opacity: 0;
    transform: translateY(-20%);
    transform: scaleY(0);
  }
  to {
    opacity: 1;
    transform: translateY(0%);
    transform: scaleY(1);
  }
}

@keyframes contract {
  from {
    opacity: 1;
    transform: scaleY(1);
  }
  to {
    opacity: 0;
    transform: scaleY(0);
  }
}
</style>
